import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import {  cargarCatalogosGenericoAsync,cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';


class FormCli17  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            cliente_sel: null,
            tipoSaldo: 'CLI',
            tipo_sel:null,
            vendedor_sel:null,
            vendedores:[],
            tipos:[],
            conceptosNDebitoPorTipo:[],
            fechaDesde: null,
            fechaHasta: null,
            Saldo: false,
        };
        this.changeComponents = this.changeComponents.bind(this);
        this.cambiarValoresInput = this.cambiarValoresInput.bind(this);
        this.impRptEstadoCuenta = this.impRptEstadoCuenta.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.seleccConceptosNDebitoPorTipo=this.seleccConceptosNDebitoPorTipo.bind(this);
    }

    cambiarValoresInput(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    changeComponents(event){

        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        
        this.setState({[name]: value});
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 4 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;
          cargarCatalogosGenericoAsync('/clientes', query, callback);
        }
    }
    cargarCatalogoConceptosNDebito(){
        return new Promise((resolve, reject) => {
          global_axios.get('/catalogos?tipo=otros&opcion=NDCLIENTEREPO')
            .then((response)=>{
            resolve(response.data);
          })
          .catch((err)=>{
            reject('Error al cargar datos del catálogo de conceptos de Nota de Débito: ' + err);
          });
        });
      }
      seleccConceptosNDebitoPorTipo(){
        let conceptosNDPorTipo = [];
        this.state.tipos.forEach((conceptoND)=>{
            conceptosNDPorTipo.push({
              value: conceptoND.Codigo,
              label: conceptoND.Descripcion + '(' + conceptoND.Codigo + ')'
            });
        });
        this.setState({conceptosNDebitoPorTipo: conceptosNDPorTipo, tipo_sel: null});
      }
    componentDidMount(){
        let fechaProceso = getFechaProcesoPorModulo('05')
            let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
            let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
            this.setState({fechaDesde: fechaDesde, fechaHasta:fechaHasta})

        Promise.all([
            this.cargarCatalogoConceptosNDebito(),
            
            cargarCatalogos_Otros('GEN-VENDEDORES-REPO'),
            this.props.generar_LogAuditoriaIngresoForm('0117')
            
         ])
        .then(([ tipos,vendedores ]) => { 
            console.log(tipos)
            this.setState({
                tipos,vendedores});
            this.seleccConceptosNDebitoPorTipo();   
        })
     
        .catch(error=>{
            alert(error);
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0117');
    }

    impRptEstadoCuenta(){
        let urlRpt 
        if(this.state.Saldo===true){
            urlRpt = '&rpt=156'
        }else{
            urlRpt = '&rpt=107';
        }
            urlRpt += '&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)
            //let urlRpt = '&rpt=107';
            if(this.state.cliente_sel!==null){
                 urlRpt += '&param3='+this.state.cliente_sel.value;
            }
            if(this.state.vendedor_sel!==null){
                urlRpt += '&param4='+this.state.vendedor_sel.value;
           }
           if(this.state.tipo_sel!==null){
                urlRpt += '&param5='+this.state.tipo_sel.value;
            }
            visualizarReporteEnPdf(urlRpt);
       
    }
    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('05')
        let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        
        this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta})        
        this.setState({ cliente_sel: null, tipo_sel:null, vendedor_sel:null, Saldo: false});
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
            <HeaderForm>
                <TituloForm>Cheque Canjeado-Protestado</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-6'>
                            <LabelForm>Cliente:</LabelForm>
                                <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{this.setState({cliente_sel: value, cheques: []})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-6'>
                            <LabelForm>Vendedor:</LabelForm>
                            <ReactSelect options={ this.state.vendedores } value={this.state.vendedor_sel} func_onChange={(value)=>{this.setState({vendedor_sel: value!==null?value:null})}}/>
                        </ContainerCol>    
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-6'>
                            <LabelForm>Tipo:</LabelForm>
                            <ReactSelect options={ this.state.conceptosNDebitoPorTipo } value={this.state.tipo_sel} 
                                func_onChange={(value)=>{this.setState({tipo_sel: value!==null?value:null})}
                                            }/>
                        </ContainerCol>
                    </Row>

                    <Row>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha Desde:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha Hasta:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-3' margen_abajo='4'>
                            <LabelForm><input type='checkbox' name='Saldo' checked={this.state.Saldo} 
                            onChange={this.cambiarValoresInput}/> Sin Saldo</LabelForm>
                        </ContainerCol> 
                    </Row>
            
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.impRptEstadoCuenta}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
} 

const mapStateToProps = ((state) => {
    return { tipoUsuario: state.sesion.valoresSesionForm.TipoUsuario ,
        fechaProceso: state.sesion.valoresSesionForm.FechaProceso
    }
    
});

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FormCli17);